import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Bars3Icon,
  ChevronDownIcon,
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext.tsx';
import { useSettings } from '../contexts/SettingsContext.tsx';
import GlobalSearch from './shell/GlobalSearch.tsx';

const getBackendUrl = (path: string) => {
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
  return `${baseUrl}${path}`;
};

interface HeaderProps {
  onMenuClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [avatarBroken, setAvatarBroken] = useState(false);
  const { user, logout } = useAuth();
  const avatarKey = typeof user?.avatar === 'string' ? user.avatar : '';
  const { settings } = useSettings();
  useEffect(() => {
    setAvatarBroken(false);
  }, [avatarKey]);

  const handleLogout = () => {
    logout();
    setIsUserMenuOpen(false);
  };

  const avatarSrc =
    typeof user?.avatar === 'string' && user.avatar
      ? user.avatar.startsWith('/uploads/')
        ? getBackendUrl(user.avatar)
        : user.avatar
      : '';

  const accountAvatar = () => (
    avatarSrc && !avatarBroken ? (
      <img
        src={avatarSrc}
        alt=""
        className="avatar"
        style={{ objectFit: 'cover' }}
        onError={() => setAvatarBroken(true)}
      />
    ) : (
      <span className="avatar" aria-hidden style={{ background: 'var(--slate-100)', color: 'var(--slate-400)' }}>
        <UserCircleIcon style={{ width: 22, height: 22 }} />
      </span>
    )
  );

  const userMenu = isUserMenuOpen ? (
    <div
      className="card"
      style={{
        position: 'absolute',
        right: 0,
        top: 'calc(100% + 8px)',
        width: 220,
        zIndex: 50,
        padding: 0,
      }}
    >
      <div style={{ padding: 14, borderBottom: '1px solid var(--slate-100)' }}>
        <div style={{ fontWeight: 600, fontSize: 13 }}>{user?.name || 'Usuário'}</div>
        <div className="muted">{user?.email || ''}</div>
      </div>
      <NavLink
        to="/profile"
        onClick={() => setIsUserMenuOpen(false)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '10px 14px',
          textDecoration: 'none',
          color: 'var(--slate-700)',
          fontSize: 13,
        }}
      >
        <UserCircleIcon style={{ width: 16, height: 16 }} />
        Meu Perfil
      </NavLink>
      <button
        type="button"
        onClick={handleLogout}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '10px 14px',
          width: '100%',
          border: 'none',
          background: 'none',
          color: 'var(--red-600)',
          fontSize: 13,
          cursor: 'pointer',
          borderTop: '1px solid var(--slate-100)',
        }}
      >
        <ArrowRightOnRectangleIcon style={{ width: 16, height: 16 }} />
        Sair
      </button>
    </div>
  ) : null;

  return (
    <>
      <div className="mobile-topbar">
        <button type="button" className="hamburger" onClick={onMenuClick} aria-label="Abrir menu">
          <Bars3Icon style={{ width: 20, height: 20 }} />
        </button>
        <div className="brand-mini">
          <div className="brand-mark">
            {(settings?.companyName || 'MP')
              .split(' ')
              .filter(Boolean)
              .slice(0, 2)
              .map(w => w[0])
              .join('')
              .toUpperCase()}
          </div>
          <strong>{settings?.companyName || 'Meu Patrimônio'}</strong>
        </div>
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            aria-label="Menu da conta"
            onClick={() => setIsUserMenuOpen(o => !o)}
            style={{ border: 'none', cursor: 'pointer', background: 'none', padding: 0 }}
          >
            {accountAvatar()}
          </button>
          {userMenu}
        </div>
      </div>

      <header className="header">
        <div className="header-left">
          <div className="breadcrumb">Meu Patrimônio</div>
          <h1 className="page-title" style={{ fontSize: 16 }}>
            {settings?.companyName || 'Gestão patrimonial'}
          </h1>
        </div>
        <div className="header-right">
          <GlobalSearch />
          <div style={{ position: 'relative' }}>
            <button
              type="button"
              onClick={() => setIsUserMenuOpen(o => !o)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              <span className="muted" style={{ fontSize: 13 }}>
                {user?.name || 'Usuário'}
              </span>
              {accountAvatar()}
              <ChevronDownIcon style={{ width: 16, height: 16, color: 'var(--slate-400)' }} />
            </button>
            {userMenu}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
